// extracted by mini-css-extract-plugin
module.exports = {"main":"friendList_main__xSTTr","name":"friendList_name__3lCR5"};